<template>
    <div class="d-flex align-items-center justify-content-between border-top totalR pt-4 mt-4" v-if="getList.totalRecords > 0">
        <p class="m-0">
            Total Records <span class="totalRecords">{{getList.totalRecords}}</span>
        </p> 
        <paginate
        	v-model="page"
            :page-count="Math.ceil(getList.totalRecords/pageLimit_parent)"
            :page-range="3"
            :click-handler="fetchData"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'">

            <span slot="breakViewContent">
				<input type="number" class="customType-number" v-model.number="pageno" v-on:keyup.enter="setPageNumber()" placeholder="...">
			</span>
        </paginate>
    </div>
</template>
<script>
    export default {
        name: 'PAGINATION',
        data () {
            return {
            	pageno : "",
            	page : 1
            }
        },
        props:['getList','pageLimit_parent'],
        methods:{
            fetchData(pageNum){
                this.$parent.page = pageNum
                this.$parent.listing()
                this.pageno = ""
            },
            setPageNumber(){
            	if(this.pageno > 0 && this.pageno <= (Math.ceil(this.getList.totalRecords/this.pageLimit_parent)) && this.page != this.pageno){
            		this.fetchData(this.pageno)
            		this.page = this.pageno
	            	this.pageno = ""
            	}
            }
        }
    }
</script>
<style type="text/css">
.pagination {
    float: right;
}
.pagination li{
    margin: 0;
}
.pagination li a {
    color: var(--fadetext);
    display: inline-block;
    background: var(--lightgraycolor);
    border-radius: 0;
    min-width: 40px;
    height: 35px;
    text-align: center;
    line-height: 34px;
    font-size: 18px;
    font-weight: normal;
    padding: 0 15px;
    border: 1px solid var(--bordercolor);
    border-right: 0;
    font-size: 14px;
}
.pagination li:last-child {
    margin: 0;
    border-right: 1px solid var(--bordercolor);
}
.pagination li.active a {
    background: var(--themecolor);
    color: var(--white);
    display: block;
    border-color: var(--themecolor);
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input.customType-number {
    width: 10px;
    height: 30px;
    padding: 0;
}
input.customType-number:focus{
    width: 40px;
  }
.totalR {
    padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/fxView/shared/pagination.vue